// 请求验证码地址
export const applyCaptchaUrl = '/web/captcha/sc/apply'
// 验证验证码地址
// '/web/captcha/sc/validate/{captchaTicket}/{captchaValue}'
export const validateCaptchaUrl = '/web/captcha/sc/validate'
// /web/captcha/sms/validate/{captchaTicket}/{captchaValue}
export const validateShortMessageCaptchaUrl = '/web/captcha/sms/validate'
// 登录地址
export const loginUrl = '/web/rest/account/login'
// 不带验证码的登录地址
export const loginWithoutCaptchaUrl = '/web/rest/account/loginwc'
// 发送短信验证码的地址
export const sendShortMessageCodeUrl = '/web/rest/sms/sendSmsCode'
// 发送短信验证码的地址 没有验证是否存在
export const sendShortMessageCodeUrlApply = '/web/captcha/sms/apply'
// 短信验证码登录
export const shortMessageLoginUrl = '/web/rest/sms/login'
// 退出登录
// '/web/rest/logout/{ticketGrantTicketId}'
export const logoutUrl = '/web/rest/logout'
// 认证授权地址
export const authUrl = '/web/oauth/token'
